import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FA9A5868-724C-429E-897B-72AD25186E2D
 * name view-list-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-list-outline.svg
 * tags
 * - View 
 */
export const ViewListOutlineIcon = createSvgIcon(<><path d="M3 5V19H20V5H3M7 7V9H5V7H7M5 13V11H7V13H5M5 15H7V17H5V15M18 17H9V15H18V17M18 13H9V11H18V13M18 9H9V7H18V9Z" /></>, 'ViewListOutlineIcon');
export default ViewListOutlineIcon